enum ROUTE {
  HOME = '/',
  GAME_LIST = '/games/:currentPage',
  GAME_PAGE = '/game/:gameID',
  LOGIN = '/login',
  LOGOUT = '/logout',
  ERROR = '*',
}

type TArgs =
  | { path: ROUTE.HOME }
  | { path: ROUTE.GAME_LIST; params: { currentPage: number | string } }
  | { path: ROUTE.GAME_PAGE; params: { gameID: number | string } }
  | { path: ROUTE.LOGIN }
  | { path: ROUTE.LOGOUT }
  | { path: ROUTE.ERROR };

type TArgsWithParams = Extract<TArgs, { path: any; params: any }>;

const createPath = (args: TArgs) => {
  if (Object.prototype.hasOwnProperty.call(args, 'params') === false) return args.path;

  return Object.entries((args as TArgsWithParams).params).reduce(
    (previousValue: string, [param, value]) => previousValue.replace(`:${param}`, `${value}`),
    args.path
  );
};

export { createPath, ROUTE };
